// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var className = "max-[768px]:[&_*_>_input]:text-[16px] max-[768px]:[&_*_>_textarea]:text-[16px]";

exports.className = className;
/* No side effect */
